import React from 'react';
import {useField} from 'formik';
import {registerLocale} from 'react-datepicker';
import nl from 'date-fns/locale/nl';
registerLocale('nl', nl);

import 'react-datepicker/dist/react-datepicker.css';
import GenericDatePicker from '../generic-date-picker/GenericDatePicker';

function FormikDayPicker({name, disabled, label, ...props}) {
    let [, fieldMeta, fieldHelpers] = useField(name);

    return (
        <GenericDatePicker
            name={name}
            label={label}
            disabled={disabled}
            showTimeSelect={false}
            showWeekNumbers={false}
            onKeyDown={(e) => {
                e.preventDefault();
            }}
            selected={fieldMeta.value ? new Date(+fieldMeta.value) : null}
            onChange={(v) => fieldHelpers.setValue(Date.parse(v))}
            dateFormat={'dd MMM yyyy'}
            {...props}
        />
    );
}

export {FormikDayPicker};
